import React, { useEffect, useState } from "react";
import Container from "../components/Container";
import image from "../assets/EarthenSuiteImg/ES1.jpg";
import TopBannerSection from "../components/TopBannerSection";
import EarthenImageList from "../components/TheEarthenSuite/EarthenImageList";
import EarthenMobileImageList from "../components/TheEarthenSuite/EarthenMobileImageList";
import EarthenSuitsDescription from "../components/TheEarthenSuite/EarthenSuitsDescription";
import EarthenSuitesDetail from "../components/TheEarthenSuite/EarthenSuitesDetail";
import Amenities from "../components/suites/Amenities";
import EarthenPrice from "../components/TheEarthenSuite/EarthenPrice";
import EarthenOtherSuites from "../components/TheEarthenSuite/EarthenOtherSuites";

const TheEarthenSuite = () => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 768);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <Container>
      <TopBannerSection Image={image} Quote={"The Earthen Suite"} />
      <br />
      {isDesktop ? <EarthenImageList /> : <EarthenMobileImageList />}
      <EarthenSuitsDescription />
      <EarthenSuitesDetail />
      <Amenities />
      <EarthenPrice />
      <EarthenOtherSuites />
    </Container>
  );
};

export default TheEarthenSuite;
